import React from 'react';
import { LazyGigPageDesBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const DesBanner: React.FC = () => (
  <BannerWrapper>
    <LazyGigPageDesBanner />
  </BannerWrapper>
);
